// extracted by mini-css-extract-plugin
export default {"errors":"error__errors___TVVZc","errors-svg":"error__errors-svg___iFHu2","errors-heading":"error__errors-heading___uaVe_","errors-body":"error__errors-body___xeV5O"};